import {
  ACTION_TYPES,
  BASE_DOC_URL_VB,
  FIELD_KEYS,
} from 'app/developer-v3/constants';

import type { ActionType } from 'app/developer-v3/types';

const getFormFields = (actionType: ActionType) => {
  const isCreates = actionType === ACTION_TYPES.creates;
  const expectedOutput = isCreates
    ? 'This Create request must return an object'
    : 'This Search request must return an array';
  const docsUrl = `${BASE_DOC_URL_VB}/build/response-types`;

  return [
    {
      label: 'API Endpoint',
      key: FIELD_KEYS.perform,
      type: 'request-editor',
      required: true,
      helpText: `Enter the URL where Zapier will make the request and send the input form data. <strong>${expectedOutput}</strong>. <a href="${docsUrl}" target="_blank">Learn More</a>.`,
    },
  ];
};

export default getFormFields;
